import {
    DialogPositioningBehavior,
    DialogProps,
    DialogType,
    DialogWidget
  } from '@tableau/widgets';
  import React from 'react';

  import { Messages } from '~src/codegen/Localize';
  import { CloseAndDismiss, ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
  import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

import { KMSKeyPolicyView } from '../components/KMSKeyPolicyView';


export const openKMSKeyPolicyDialog = (externalKeyId: string, isAfterKeyGeneration: boolean): void => {
      ReactModalService.openCustom(closeAndDismiss => {
          const dialogProps = ReactModalService.getDefaultDialogProps({
              type: DialogType.NormalWithTitleBar,
              title: Messages.extractEncryption_KMSKeyPolicyDialog_Title(),
              testId: 'kms-key-policy-dialog',
              showCloseButton: true,
              dialogWidth: TabDialogWidth.width500px,
              positioningBehavior: DialogPositioningBehavior.Draggable,
              shouldNotCloseOnGlassClick: true
          }, closeAndDismiss);
          return getDialogWidget(dialogProps, closeAndDismiss, externalKeyId, isAfterKeyGeneration);
      });

  };


  function getDialogWidget(dialogProps: DialogProps, closeAndDismiss: CloseAndDismiss, externalKeyId: string, isAfterKeyGeneration: boolean) {
    return (
      <DialogWidget {...dialogProps}>
        {<KMSKeyPolicyView closeDialog={closeAndDismiss} externalKeyId={externalKeyId} isAfterKeyGeneration={isAfterKeyGeneration} />}
      </DialogWidget>
    );
  }